import { render, staticRenderFns } from "./gameRule.vue?vue&type=template&id=228a489f&scoped=true&"
import script from "./gameRule.vue?vue&type=script&lang=js&"
export * from "./gameRule.vue?vue&type=script&lang=js&"
import style0 from "./gameRule.vue?vue&type=style&index=0&id=228a489f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228a489f",
  null
  
)

export default component.exports